import HomeIcon from '@mui/icons-material/Home';
import { ListItemButton, Box, List, Divider, ListItem, ListItemIcon, ListItemText, ListSubheader, Typography, Tooltip } from "@mui/material";
import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { ThemeContext } from "../context/ThemeProvider";
import Style from "../css/sidebar.module.scss";
import Logo from "../assets/logo.png"
import SettingsIcon from '@mui/icons-material/Settings';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ListIcon from '@mui/icons-material/List';
import SellIcon from '@mui/icons-material/Sell';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';



export default function Sidebar() {
  const { drawerSilde } = useContext(ThemeContext)
  const { pathname } = useLocation()

  const sidebarList = [
    {
      header: "Dashboard",
      body: [
        { icon: <HomeIcon sx={{ color: '#fff' }} />, primary: "Home", href: '/' }
      ]
    },
    {
      header: "Config",
      body: [
        { icon: <AttachFileIcon sx={{ color: '#fff' }} />, primary: "Config Meta", href: '/configmeta' },
        { icon: <SettingsIcon sx={{ color: '#fff' }} />, primary: "Edit Config Meta", href: '/editconfigmeta' }
      ]
    },
    {
      header: "Coupon",
      body: [
        { icon: <CloudUploadIcon sx={{ color: '#fff' }} />, primary: "Upload Coupons", href: '/upload' },
        { icon: <AddCircleIcon sx={{ color: '#fff' }} />, primary: "Create Coupons", href: '/createcouponcard' },
        { icon: <ListIcon sx={{ color: '#fff' }} />, primary: "Coupon List", href: '/couponlist' },
        { icon: <SellIcon sx={{ color: '#fff' }} />, primary: "All Coupon Card", href: '/getallcoupon' },
        { icon: <BookmarkBorderIcon sx={{ color: '#fff' }} />, primary: "Order Coupons", href: '/order' },
      ]
    },
    {
      header: "Khiladi Adda Coupons",
      body: [
        { icon: <ListIcon sx={{ color: '#fff' }} />, primary: "KA Coupons List", href: '/kacouponlist' },
        { icon: <SellIcon sx={{ color: '#fff' }} />, primary: "Order KA Coupons", href: '/kaorder' },
      ]
    },
    {
      header: "Voucher Publisher",
      body: [
        { icon: <FormatAlignLeftIcon sx={{ color: '#fff' }} />, primary: "Publishers List", href: '/voucherPublishers' },
        { icon: <FormatAlignLeftIcon sx={{ color: '#fff' }} />, primary: "Bank Details", href: '/bankDetails' },
      ]
    },
    {
      header: "Quick Silver Coupons",
      body: [
        { icon: <ListIcon sx={{ color: '#fff' }} />, primary: "QS Coupon List", href: '/qscouponlist' },
        { icon: <SellIcon sx={{ color: '#fff' }} />, primary: "Order QS Coupons", href: '/qsorder' },
        { icon: <SellIcon sx={{ color: '#fff' }} />, primary: "link sku & Image", href: '/linksku' },
      ]
    },
    {
      header: "Coupon Store",
      body: [
        { icon: <LocalOfferIcon sx={{ color: '#fff' }} />, primary: "Publisher Discounts", href: '/discounts' },
      ]
    },
    {
      header: "Category",
      body: [
        { icon: <FormatAlignLeftIcon sx={{ color: '#fff' }} />, primary: "Categoires", href: '/categoires' },
      ]
    },
    {
      header: "Topupx",
      body: [
        { icon: <BookmarkBorderIcon sx={{ color: '#fff' }} />, primary: "Topupx Orders ", href: '/topupx-orders' }
      ]
    },
    {
      header: "Payment",
      body: [
        { icon: <BookmarkBorderIcon sx={{ color: '#fff' }} />, primary: "History ", href: '/history' }
      ]
    },
  ]


  return (
    <>

      <Box className={drawerSilde ? Style.sidebar_open : Style.sidebar_close}>
        <Box className={Style.logo}><img src={Logo} alt='logo' /></Box>
        <Divider></Divider>
        {sidebarList?.map((item, idx) => {
          return (
            <>
              <List key={idx} subheader={
                drawerSilde && <ListSubheader sx={{ bgcolor: '#63573b', color: 'primary.main' }}>{item?.header}</ListSubheader>
              }>
                {item?.body?.map((bodyItm, bodyIdx) => {
                  return (
                    <>
                      <Link key={bodyIdx} style={{ textDecoration: "none", color: '#fff' }} to={bodyItm?.href}>
                        <Tooltip title={bodyItm?.primary} placement='right'>
                          <ListItem disablePadding className={bodyItm.href == pathname && Style?.actvie_link}>
                            <ListItemButton>
                              <ListItemIcon>{bodyItm?.icon}</ListItemIcon>
                              {drawerSilde && <ListItemText primary={bodyItm?.primary} />}
                            </ListItemButton>
                          </ListItem>
                        </Tooltip>
                      </Link>
                    </>
                  )
                })}

              </List>
            </>
          )
        })}
      </Box>
    </>
  );
}
